import { SearchResultArtist as GQLItem } from '../../generated/api.graphql';
import { take } from '../../util';
import * as ArtistGenre from './ArtistGenre';

export type SearchResultArtist = {
  id?: number;
  name: string;
  imageUrl?: string;
  soundchartsUuid?: string;
  countryCode: string;
  genres: ArtistGenre.ArtistGenre[];
};

export const fromGql = (item: GQLItem): SearchResultArtist => ({
  ...take<SearchResultArtist>(item, 'id', 'name', 'imageUrl', 'soundchartsUuid', 'countryCode'),
  genres: item.genres ? item.genres.map(ArtistGenre.fromGql) : [],
});

export const fromGqlCollection = (items: GQLItem[]): SearchResultArtist[] => (items || []).map(item => fromGql(item));
